module.exports = __webpack_public_path__ + "5e5704de4efcabd40ffae95ccae811c7.png";